import {
  RPT_PRODUCTTYPE_LISTING_SET_DATA,
  RPT_PRODUCTTYPE_LISTING_ERROR,
  RPT_PRODUCTTYPE_LISTING_IS_LOADING,
  RPT_PRODUCTTYPE_LISTING_ON_SEARCH_CHANGE_DATA,
  RPT_PRODUCTTYPE_LISTING_CLEAN_UP
} from '../../../constants/index';
import { initialRptProductTypeListingState } from '../initialReportState';

const rptProductTypeListingReducer = (state = initialRptProductTypeListingState, action) => {
  const { payload, type } = action;

  switch (type) {
    case RPT_PRODUCTTYPE_LISTING_ERROR: {
      const { showMessage, errorMessage } = payload;
      return {
        ...state,
        isError: showMessage ? true : false,
        showMessage: showMessage,
        message: errorMessage
      };
    }
    case RPT_PRODUCTTYPE_LISTING_SET_DATA: {
      const { resultData } = payload;

      return {
        ...state,
        rptList: resultData.reportData,
        filterData: resultData.filterData
      };
    }
    case RPT_PRODUCTTYPE_LISTING_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading: isLoading
      };
    }

    case RPT_PRODUCTTYPE_LISTING_CLEAN_UP: {
      let { data } = payload;

      return {
        ...state,
        ...data
      };
    }

    case RPT_PRODUCTTYPE_LISTING_ON_SEARCH_CHANGE_DATA: {
      let { data } = payload;

      return {
        ...state,
        filterOptions: {
          ...state.filterOptions,
          ...data
        }
      };
    }
    default:
      return state;
  }
};

export default rptProductTypeListingReducer;
